import { createEntityAdapter } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
import { createAppSlice } from "../../../shared/lib/store/createAppSlice.js";
import { name } from "../config/name.js";
import { ComparisonShiftDirectionEnum } from "./types.js";
const adapter = createEntityAdapter({
  sortComparer: (a, b) => a.addedBy - b.addedBy
});
const initialState = {
  ...adapter.getInitialState(),
  isShowDifference: false,
  isIrrelevant: false,
  selected: []
};
const slice = createAppSlice({
  name,
  initialState,
  reducers: {
    addItem: adapter.addOne,
    removeItem: adapter.removeOne,
    removeAllItems: adapter.removeAll,
    actualizeItems: (state, action) => {
      const outdatedItems = state.ids.filter((id) => !action.payload.includes(id));
      if (outdatedItems.length > 0) {
        adapter.removeMany(state, outdatedItems);
        state.isIrrelevant = true;
      }
    },
    showDifferenceToggle: (state) => {
      state.isShowDifference = !state.isShowDifference;
    },
    setShowDifference: (state, action) => {
      state.isShowDifference = action.payload;
    },
    setIrrelevant: (state, action) => {
      state.isIrrelevant = action.payload;
    },
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    fillSelected: (state, action) => {
      const sortedIds = adapter.getSelectors().selectIds(state);
      state.selected = [
        ...state.selected.filter((id) => sortedIds.includes(id)),
        ...sortedIds.filter((id) => !state.selected.includes(id))
      ].slice(0, action.payload);
    },
    shiftAll: (state, action) => {
      const sortedIds = adapter.getSelectors().selectIds(state);
      if (sortedIds.length < 1) {
        return;
      }
      if (!state.selected.length) {
        state.selected.push(sortedIds[0]);
      }
      for (let i = 0; i < state.selected.length; i++) {
        const currentIndex = sortedIds.indexOf(state.selected[i]);
        if (currentIndex === -1) {
          continue;
        }
        const loopedIds = [
          state.selected[i],
          ...sortedIds.slice(currentIndex + 1),
          ...sortedIds.slice(0, currentIndex)
        ];
        if (loopedIds.length < 1) {
          continue;
        }
        const newSelected = action.payload.direction === ComparisonShiftDirectionEnum.Right ? loopedIds[1] : loopedIds[loopedIds.length - 1];
        state.selected[i] = newSelected;
      }
    },
    shift: (state, action) => {
      const sortedIds = adapter.getSelectors().selectIds(state);
      const selectedIndex = state.selected.indexOf(action.payload.itemId);
      const currentIndex = sortedIds.indexOf(action.payload.itemId);
      if (selectedIndex === -1 || currentIndex === -1) {
        return;
      }
      const loopedIds = [
        action.payload.itemId,
        ...sortedIds.slice(currentIndex + 1),
        ...sortedIds.slice(0, currentIndex)
      ].filter((id) => id === action.payload.itemId || !state.selected.includes(id));
      if (loopedIds.length < 2) {
        return;
      }
      const newSelected = action.payload.direction === ComparisonShiftDirectionEnum.Right ? loopedIds[1] : loopedIds[loopedIds.length - 1];
      state.selected[selectedIndex] = newSelected;
    }
  }
});
const reducer = persistReducer(
  {
    key: slice.reducerPath,
    version: 1,
    storage,
    blacklist: ["selected", "isShowDifference", "isIrrelevant"]
  },
  slice.reducer
);
const { actions, reducerPath } = slice;
const selectors = adapter.getSelectors();
export {
  actions,
  adapter,
  reducer,
  reducerPath,
  selectors,
  slice
};
